import React from 'react';
import pt from 'prop-types';

import { Select } from '@metarouter-private/mr-mui';

export default function RevisionSelect({ label, playbooks, value, onChange, testId }) {
  const options = playbooks.map(playbook => ({
    value: playbook.id,
    label: `Revision ${playbook.revision} — ${formatDate(playbook.createdAt)}`,
  }));

  const handleChange = event => onChange(event.target.value);

  return (
    <Select
      size="small"
      label={label}
      options={options}
      value={value ?? ''}
      onChange={handleChange}
      data-test-id={testId}
    />
  );
}

function formatDate(timestamp) {
  return new Date(timestamp).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

RevisionSelect.propTypes = {
  label: pt.string.isRequired,
  playbooks: pt.array.isRequired,
  value: pt.string,
  onChange: pt.func.isRequired,
  testId: pt.string,
};
